import { Component, Host, Prop, h } from '@stencil/core';

export type OneToFour = 1 | 2 | 3 | 4;
export type OneToEight = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8;
export type OneToTwelve = 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8 | 9 | 10 | 11 | 12;

@Component({
  tag: 'anchor-grid-column',
  styleUrl: 'grid-column.scss',
  shadow: true,
})
export class GridColumn {
  /**
   * Set the number of columns the grid-column should span in the default screen size (mobile).
   */
  @Prop() column: OneToFour;

  /**
   * Set the number of columns the grid-column should span in the small screen size.
   */
  @Prop() smColumn?: OneToEight;

  /**
   * Set the number of columns the grid-column should span in the medium screen size.
   */
  @Prop() mdColumn?: OneToTwelve;

  /**
   * Set the number of columns the grid-column should span in the large screen size.
   */
  @Prop() lgColumn?: OneToTwelve;

  /**
   * Set the number of columns the grid-column should span in the extra large screen size.
   */
  @Prop() xlColumn?: OneToTwelve;

  // eslint-disable-next-line class-methods-use-this
  render() {
    return (
      <Host>
        <div class={'anchor-c-grid-column'}>
          <slot></slot>
        </div>
      </Host>
    );
  }
}
